// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__Fu9T4","obliqueLine":"styles_obliqueLine__a3hRi","change":"styles_change__bY0n0"};